/**
 * Toast facade — sonner backed
 *
 * Foydalanish:
 *   import { toast } from '@/shared/ui/toast';
 *   toast.success("Mahsulot saqlandi");
 *   toast.error("Ulanishda xato");
 *
 * Yagona haqiqat manbai — sonner. Mavjud callerlar uchun API saqlangan.
 */

import { toast as sonnerToast } from 'sonner';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

/** Sonner toast id (string | number) — loading→success/error yangilashda ishlatiladi. */
export type ToastId = string | number;

export const toast = {
  success: (message: string, duration?: number): void => {
    sonnerToast.success(message, duration !== undefined ? { duration } : undefined);
  },
  error: (message: string, duration?: number): void => {
    sonnerToast.error(message, duration !== undefined ? { duration } : undefined);
  },
  warning: (message: string, duration?: number): void => {
    sonnerToast.warning(message, duration !== undefined ? { duration } : undefined);
  },
  info: (message: string, duration?: number): void => {
    sonnerToast.info(message, duration !== undefined ? { duration } : undefined);
  },
  /**
   * Uzoq amal uchun spinner-toast. Qaytgan id'ni success/error/dismiss'ga uzatib
   * AYNAN shu toast'ni yangilash mumkin (progress: "N/total chiqarildi").
   */
  loading: (message: string, id?: ToastId): ToastId => {
    return sonnerToast.loading(message, id !== undefined ? { id } : undefined);
  },
  /** loading bilan ochilgan toast'ni id orqali success'ga aylantirish (progress yakuni). */
  successId: (id: ToastId, message: string, duration?: number): void => {
    sonnerToast.success(message, { id, ...(duration !== undefined ? { duration } : {}) });
  },
  /** loading bilan ochilgan toast'ni id orqali error'ga aylantirish. */
  errorId: (id: ToastId, message: string, duration?: number): void => {
    sonnerToast.error(message, { id, ...(duration !== undefined ? { duration } : {}) });
  },
  dismiss: (id: ToastId): void => {
    sonnerToast.dismiss(id);
  },
};
